module.exports = __webpack_public_path__ + "5f9cbc7129d68fb607243a1267fcda2b.svg";